
// import React, { useState, useMemo, useEffect } from "react";
// import FilterBar from "./FilterBar";
// import "../style/maincontent.css";
// import CloseIcon from "@mui/icons-material/Close";
// import { jsPDF } from "jspdf";
// import IEW_logo from "../assets/images/IEW_logo.png";
// import axios from "axios";
// import { ThreeDot } from "react-loading-indicators";
// import Pagination from "@mui/material/Pagination";
// import { Result, Button } from "antd";
// import { useNavigate } from "react-router-dom";
// import { X, Video, BookOpen } from "lucide-react";
// import { AbstractAPI } from "../api";

// // Import all 25 dashboard images
// import img1 from "../assets/images/Dashboard/1.jpg";
// import img2 from "../assets/images/Dashboard/2.jpg";
// import img3 from "../assets/images/Dashboard/3.jpg";
// import img4 from "../assets/images/Dashboard/4.jpg";
// import img5 from "../assets/images/Dashboard/5.jpg";
// import img6 from "../assets/images/Dashboard/6.jpg";
// import img7 from "../assets/images/Dashboard/7.jpg";
// import img8 from "../assets/images/Dashboard/8.jpg";
// import img9 from "../assets/images/Dashboard/9.jpg";
// import img10 from "../assets/images/Dashboard/10.jpg";
// import img11 from "../assets/images/Dashboard/11.jpg";
// import img12 from "../assets/images/Dashboard/12.jpg";
// import img13 from "../assets/images/Dashboard/13.jpg";
// import img14 from "../assets/images/Dashboard/14.jpg";
// import img15 from "../assets/images/Dashboard/15.jpg";
// import img16 from "../assets/images/Dashboard/16.jpg";
// import img17 from "../assets/images/Dashboard/17.jpg";
// import img18 from "../assets/images/Dashboard/18.jpg";
// import img19 from "../assets/images/Dashboard/19.jpg";
// import img20 from "../assets/images/Dashboard/20.jpg";
// import img21 from "../assets/images/Dashboard/21.jpg";
// import img22 from "../assets/images/Dashboard/22.jpg";
// import img23 from "../assets/images/Dashboard/23.jpg";
// import img24 from "../assets/images/Dashboard/24.jpg";
// import img25 from "../assets/images/Dashboard/25.jpg";


// const CATEGORY_IMAGE_MAP = {
//   "AI and Digital Transformation": img1,
//   "AI, Digital Transformation & New Technologies": img1,
//   "Alternative Fuels & Renewable Energy": img2,
//   "ALTERNATIVE FUELS & RENEWABLES DEVELOPMENT & TECHNOLOGY": img2,
//   "Biofuels and Alternative Fuels": img3,
//   "Carbon Capture Utilisation and Storage": img4,
//   "Clean Cooking": img5,
//   "ClimateTech": img6,
//   "DIGITAL TRANSFORMATION & NEW TECHNOLOGY": img7,
//   "Energy Markets, Strategies & Finance": img8,
//   "Energy Transition, Decarbonisation & Environment": img9,
//   "Energy Transition, Decarbonisation": img9,
//   "EXPLORATION, PRODUCTION & DEVELOPMENT": img10,
//   "Future Mobility": img11,
//   "Health, Safety, Security and Environment": img12,
//   "Hydrocarbons - Exploration, Production & Development": img13,
//   "Hydrocarbons: Exploration, Production and Development": img13,
//   "Hydrogen Production, Development & End Use": img14,
//   "Manufacturing & Industrialisation": img15,
//   "Marine Operations, Logistics and Supply Chain": img16,
//   "Mining & Minerals": img17,
//   "Natural Gas and LNG Processing, Operations": img18,
//   "GAS/LNG PROCESSING, OPERATIONS & TECHNOLOGY": img18,
//   "Gas: Processing, Operations & Technology": img18,
//   "Organisational Readiness and Operational Excellence": img19,
//   "OPERATIONAL EXCELLENCE": img19,
//   "People Development": img20,
//   "PROJECT MANAGEMENT": img21,
//   "Refining & Petrochemicals Technology, Operations": img22,
//   "Renewable Energy": img23,
//   "Transportation, Storage & Infrastructure": img24,
//   "Transportation, Storage and Infrastructure": img24,
//   "TRANSPORTATION, STORAGE & INFRASTRUCTURE": img24,
//   "Utilities & Power Generation": img25,
// };


// const DEFAULT_CATEGORY_IMAGE = img1;

// const getCategoryImage = (categoryName) => {
//   if (!categoryName) return DEFAULT_CATEGORY_IMAGE;

//   // Direct match
//   if (CATEGORY_IMAGE_MAP[categoryName]) {
//     return CATEGORY_IMAGE_MAP[categoryName];
//   }

//   // Case-insensitive match
//   const lowerCategoryName = categoryName.toLowerCase().trim();
//   const matchedKey = Object.keys(CATEGORY_IMAGE_MAP).find(
//     key => key.toLowerCase().trim() === lowerCategoryName
//   );

//   if (matchedKey) {
//     return CATEGORY_IMAGE_MAP[matchedKey];
//   }

//   // Partial match (if category name contains any key or vice versa)
//   const partialMatchKey = Object.keys(CATEGORY_IMAGE_MAP).find(
//     key => {
//       const keyLower = key.toLowerCase();
//       return lowerCategoryName.includes(keyLower) || keyLower.includes(lowerCategoryName);
//     }
//   );

//   if (partialMatchKey) {
//     return CATEGORY_IMAGE_MAP[partialMatchKey];
//   }

//   return DEFAULT_CATEGORY_IMAGE;
// };

// // export const formatBoldText = (text = "") => {
// //   if (!text) return text;

// //   const parts = text.split(/(\*\*.*?\*\*)/g);

// //   return parts.map((part, index) => {
// //     if (part.startsWith("**") && part.endsWith("**")) {
// //       const clean = part.slice(2, -2); // remove **
// //       return <strong key={index}>{clean}</strong>;
// //     }
// //     return part;
// //   });
// // };


// // export const highlightText = (text, query) => {
// //   if (!query) return formatBoldText(text);

// //   const regex = new RegExp(`(${query})`, "gi");

// //   const parts = text.split(regex);

// //   return parts.map((part, index) => {
// //     if (part.toLowerCase() === query.toLowerCase()) {
// //       return (
// //         <mark key={index}>
// //           {formatBoldText(part)}
// //         </mark>
// //       );
// //     }
// //     return <span key={index}>{formatBoldText(part)}</span>;
// //   });
// // };

// // Helper: split and render with bold as new blocks
// export const formatBoldText = (text = "") => {
//   if (!text) return null; // or <></>

//   // Split on **...** (non-greedy)
//   const parts = text.split(/(\*\*.*?\*\*)/g);

//   return parts.map((part, index) => {
//     if (part.startsWith("**") && part.endsWith("**")) {
//       const clean = part.slice(2, -2).trim();
//       // Each bold → new paragraph/block
//       return (
//         <p key={index} className="bold-paragraph" style={{ margin: "1em 0 0.5em" }}>
//           <strong>{clean}</strong>
//         </p>
//       );
//     }

//     // Non-bold parts → normal text (we'll wrap later if needed)
//     if (part.trim()) {
//       return <span key={index}>{part}</span>;
//     }
//     return null;
//   });
// };

// // Updated highlightText – now composes with the block-aware bold formatter
// export const highlightText = (text, query) => {
//   if (!query) {
//     return formatBoldText(text);
//   }

//   // First split on the search query (case insensitive)
//   const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");
//   const parts = text.split(regex);

//   return parts.map((part, index) => {
//     const lowerPart = part.toLowerCase();
//     const lowerQuery = query.toLowerCase();

//     if (lowerPart === lowerQuery) {
//       // Highlighted term → wrap in <mark>, but still let formatBoldText handle ** inside it
//       return <mark key={index}>{formatBoldText(part)}</mark>;
//     }

//     // Non-highlighted → just pass through formatBoldText (which will create blocks for bold)
//     return formatBoldText(part);
//   });
// };
// export const highlightParagraphs = (text = "", query = "") => {
//   if (!text) return null;
//   const paras = String(text).split(/\n{2,}/g);
//   return paras.map((p, idx) => {
//     const pieces = p.split(/\n/g);
//     return (
//       <p key={idx} className="summary-paragraph">
//         {pieces.map((piece, i) => (
//           <span key={i}>
//             {highlightText(piece, query)}
//             {i < pieces.length - 1 && <br />}
//           </span>
//         ))}
//       </p>
//     );
//   });
// };

// export const splitSummaryByFullStop = (text = "", sentencesPerPara = 3) => {
//   if (!text) return [];

//   const sentences = text
//     .split(".")
//     .map(s => s.trim())
//     .filter(Boolean);

//   const paragraphs = [];
//   for (let i = 0; i < sentences.length; i += sentencesPerPara) {
//     paragraphs.push(
//       sentences.slice(i, i + sentencesPerPara).join(". ") + "."
//     );
//   }

//   return paragraphs;
// };

// const drawJustifiedParagraph = (doc, text, x, y, maxWidth, lineHeight) => {
//   const words = text.split(/\s+/);
//   let line = [];
//   let cursorY = y;

//   words.forEach((word, index) => {
//     const testLine = [...line, word].join(" ");
//     const testWidth = doc.getTextWidth(testLine);

//     if (testWidth > maxWidth && line.length > 0) {
//       const lineText = line.join(" ");
//       const spaceCount = line.length - 1;

//       if (spaceCount > 0) {
//         const textWidth = doc.getTextWidth(lineText.replace(/\s+/g, ""));
//         const extraSpace = (maxWidth - textWidth) / spaceCount;

//         let cursorX = x;
//         line.forEach((w, i) => {
//           doc.text(w, cursorX, cursorY);
//           cursorX += doc.getTextWidth(w);
//           if (i < line.length - 1) cursorX += extraSpace;
//         });
//       } else {
//         doc.text(lineText, x, cursorY);
//       }

//       cursorY += lineHeight;
//       line = [word];
//     } else {
//       line.push(word);
//     }

//     if (index === words.length - 1) {
//       doc.text(line.join(" "), x, cursorY);
//     }
//   });

//   return cursorY + lineHeight;
// };

// const makeSafeFileName = (str = "document") =>
//   str
//     .toString()
//     .trim()
//     .replace(/[^a-z0-9_\-\. ]/gi, "_")
//     .replace(/\s+/g, "_")
//     .slice(0, 120);

// const loadImageDataUrl = (url, opacity = 0.12) => {
//   return new Promise((resolve, reject) => {
//     if (!url) return resolve(null);
//     const img = new Image();
//     img.crossOrigin = "anonymous";
//     img.onload = () => {
//       try {
//         const w = img.naturalWidth;
//         const h = img.naturalHeight;
//         const canvas = document.createElement("canvas");
//         canvas.width = w;
//         canvas.height = h;
//         const ctx = canvas.getContext("2d");
//         ctx.clearRect(0, 0, w, h);
//         ctx.globalAlpha = typeof opacity === "number" ? opacity : 0.12;
//         ctx.drawImage(img, 0, 0, w, h);
//         ctx.globalAlpha = 1;
//         const dataUrl = canvas.toDataURL("image/png");
//         resolve({ dataUrl, width: w, height: h });
//       } catch (err) {
//         reject(err);
//       }
//     };
//     img.onerror = (e) => reject(e);
//     img.src = url;
//   });
// };


// const SummaryModal = ({ item, onClose, query, user, color, type }) => {
//   const [downloading, setDownloading] = useState(false);


//   useEffect(() => {
//     const onKey = (e) => e.key === "Escape" && onClose();
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, [onClose]);

//   if (!item) return null;

//   const handleDownloadPdf = async (itemToSave = item) => {
//     setDownloading(true);
//     if (!itemToSave) return;

//     let logo = null;
//     try {
//       logo = await loadImageDataUrl(IEW_logo, 0.2);
//     } catch {
//       logo = null;
//     }

//     const doc = new jsPDF({ unit: "mm", format: "a4" });

//     const pageWidth = doc.internal.pageSize.getWidth();
//     const pageHeight = doc.internal.pageSize.getHeight();
//     const margin = 15;
//     const maxLineWidth = pageWidth - margin * 2;
//     const titleFontSize = 16;
//     const labelFontSize = 11;
//     const bodyFontSize = 11;
//     const lineHeight = 6;

//     let cursorY = margin;
//     let currentPage = 1;
//     const pagesWithLogo = new Set();

//     const drawLogoOnPage = (pageNum) => {
//       if (!logo || pagesWithLogo.has(pageNum)) return;

//       doc.setPage(pageNum);
//       const logoWidth = pageWidth * 0.6;
//       const logoHeight = logoWidth * (logo.height / logo.width);
//       const x = (pageWidth - logoWidth) / 2;
//       const y = (pageHeight - logoHeight) / 2;

//       doc.addImage(logo.dataUrl, "PNG", x, y, logoWidth, logoHeight);
//       pagesWithLogo.add(pageNum);
//     };

//     const ensureLogo = () => drawLogoOnPage(currentPage);

//     const checkPageBreak = () => {
//       if (cursorY + lineHeight > pageHeight - margin) {
//         doc.addPage();
//         currentPage++;
//         cursorY = margin;
//         ensureLogo();
//       }
//     };

//     const addLabelValue = (label, value) => {
//       if (!value) return;

//       checkPageBreak();
//       doc.setFont("helvetica", "bold");
//       doc.setFontSize(labelFontSize);
//       doc.text(label, margin, cursorY);
//       cursorY += lineHeight;

//       doc.setFont("helvetica", "normal");
//       doc.setFontSize(bodyFontSize);
//       doc.splitTextToSize(String(value), maxLineWidth).forEach((line) => {
//         checkPageBreak();
//         doc.text(line, margin, cursorY);
//         cursorY += lineHeight;
//       });

//       cursorY += 2;
//     };

//     ensureLogo();

//     if (itemToSave.title) {
//       addLabelValue("Title:", itemToSave.title);
//       cursorY += 2;
//     }


//     addLabelValue("Category:", itemToSave.category);
//     addLabelValue("Subcategory:", itemToSave.subcategory || itemToSave.sub_category);
//     const paperYear =
//       itemToSave?.year ||
//       itemToSave?.years ||
//       itemToSave?.Year ||
//       itemToSave?.parent?.year;

//     addLabelValue("Year:", paperYear);

//     addLabelValue("Author:", itemToSave.author || itemToSave.submitter_first_name);
//     addLabelValue("Co-Author:", itemToSave.Coauthor);
//     const loggedInUserName =
//       user?.full_name ||
//       user?.name ||
//       user?.username ||
//       user?.email ||
//       "Guest User";

//     addLabelValue("Downloaded By:", loggedInUserName);


//     // const coAuthors = [
//     //   itemToSave.person2_first_name,
//     //   itemToSave.person3_first_name,
//     //   itemToSave.person4_first_name,
//     //   itemToSave.person5_first_name,
//     // ].filter(Boolean).join(", ");

//     // addLabelValue("Co-Authors:", coAuthors);


//     checkPageBreak();
//     doc.line(margin, cursorY, pageWidth - margin, cursorY);
//     cursorY += 8;

//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(labelFontSize);
//     doc.text("Content:", margin, cursorY);
//     cursorY += lineHeight + 2;

//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(bodyFontSize);

//     const contentRaw = itemToSave.summary ?? itemToSave.abstract ?? itemToSave.content ?? "";

//     contentRaw.split(/\n{2,}/g).forEach((para) => {
//       if (!para.trim()) return;

//       if (cursorY + lineHeight > pageHeight - margin) {
//         doc.addPage();
//         currentPage++;
//         cursorY = margin;
//         ensureLogo();
//       }

//       cursorY = drawJustifiedParagraph(
//         doc,
//         para.replace(/\n/g, " "),
//         margin,
//         cursorY,
//         maxLineWidth,
//         lineHeight
//       );
//     });

//     doc.setProperties({
//       title: itemToSave.title || "Document",
//       author: itemToSave.author || "",
//       subject: itemToSave.subcategory || "",
//     });

//     doc.save(
//       `${makeSafeFileName(
//         itemToSave.title || itemToSave.subcategory || "summary"
//       )}_summary.pdf`
//     );
//     setDownloading(false);
//   };



//   const handleDownloadPPT = async (filepath) => {
//     if (!filepath || typeof filepath !== "string") {
//       console.error("Invalid filepath:", filepath);
//       alert("No file path found");
//       return;
//     }

//     try {
//       const blob = await AbstractAPI.getFile(filepath);

//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");

//       link.href = url;
//       link.download = filepath.split("/").pop();

//       document.body.appendChild(link);
//       link.click();

//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);

//     } catch (error) {
//       console.error("Download failed:", error);
//     }
//   };


// const handleDownloadFile = async (filepath) => {
//   if (!filepath?.trim()) {
//     alert("No file path available.");
//     return;
//   }

//   try {
//     await AbstractAPI.downloadFile(filepath);
//   } catch (error) {
//     console.error("Download failed:", error);
//     alert("File download failed.");
//   }
// };

//   return (
//     <div className="modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
//       <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//         <header className="modal-header">
//           <h2 className="modal-title">{highlightText(item.title, query)}</h2>
//           <button className="modal-close" onClick={onClose} aria-label="Close summary">
//             <CloseIcon />
//           </button>
//         </header>

//         <section className="modal-body">


//           <div style={{ marginBottom: 16 }}>
//             <p>
//               <strong>Category:</strong>{" "}
//               {highlightText(item.category, query)}
//             </p>
//             <p>
//               <strong>Subcategory:</strong>{" "}
//               {highlightText(item.subcategory, query)}
//             </p>

//             <p>
//               <strong>Author:</strong>{" "}
//               {highlightText(item.author, query)}

//             </p>
//             <p>
//               <strong>Co-Author:</strong>{" "}
//               {highlightText(item.Coauthor, query)}

//             </p>

//           </div>
//           <div className="summary-wrapper" role="article">
//             <strong style={{ display: "block", textAlign: "center" }}>
//               AI Generated Abstract
//             </strong>
//             <br />

//             <div className="summary-justified">
//               {splitSummaryByFullStop(item.summaryabstract || "", 3).map((para, idx) => (
//                 <p key={idx} className="summary-paragraph">
//                   {highlightText(para, query)}
//                 </p>
//               ))}
//             </div>
//           </div>
//         </section>

//         <footer className="modal-footer">
//           <button
//             className="modal-download"
//             onClick={() => handleDownloadPdf(item)}
//             disabled={downloading}
//           >
//             {downloading ? "Generating..." : "Download Full Paper"}
//           </button>

// <button
//             className="modal-download"
//             onClick={async () => {
//               if (!item?.filepath) {
//                 alert("No file available.");
//                 return;
//               }
//               setDownloading(true);
//               try {
//                 await handleDownloadFile(item.filepath);
//               } catch (e) {
//                 console.error("Download failed:", e);
//                 alert("Download failed – check console for details.");
//               } finally {
//                 setDownloading(false);
//               }
//             }}
//             disabled={downloading || !item?.filepath}
//           >
//             {downloading ? "Downloading..." : "Download Presentation"}
//           </button>


//           {downloading && (
//             <div className="download-loader">

//               <p>Loading ...</p>
//               <ThreeDot color="#c65100" size="medium" text="" textColor="" />
//             </div>
//           )}


//           {/* <button className="modal-close-btn" onClick={onClose}>
//             Close
//           </button> */}
//         </footer>
//       </div>
//     </div>
//   );
// };

// const DEFAULTS = {
//   year: "All Years",
//   category: "All Categories",
//   subcategory: "All Subcategories",
//   author: "All Authors",
//   access: "All Content",
//   query: "",
// };

// const matchesQuery = (item, q) => {
//   if (!q) return true;

//   const text = [
//     item.title,
//     item.summary,
//     item.summaryabstract,
//     item.author,
//     item.Coauthor,
//     item.category,
//     item.subcategory,
//   ]
//     .filter(Boolean)
//     .join(" ")
//     .toLowerCase();

//   return text.includes(q);
// };


// const MainContent = ({
//   user,
//   activeTab,
//   setActiveTab,
//   onShowAuth,
//   onShowDashboard,
//   onLogout,
// }) => {
//   const navigate = useNavigate();
//   const [visibleCount, setVisibleCount] = useState(8);
//   const [filters, setFilters] = useState({ ...DEFAULTS });
//   const [excludedIds, setExcludedIds] = useState([]);
//   const [showOptionModal, setShowOptionModal] = useState(false);
//   const [selectedCategoryForAction, setSelectedCategoryForAction] = useState(null);
//   const [viewMode, setViewMode] = useState("categories");
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [selectedSubcategory, setSelectedSubcategory] = useState(null);
//   const [selectedItemForModal, setSelectedItemForModal] = useState(null);
//   const [showSummaryModal, setShowSummaryModal] = useState(false);

//   const [filtersApplied, setFiltersApplied] = useState(false);
//   const [matchedParentIds, setMatchedParentIds] = useState([]);
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [categoryImages, setCategoryImages] = useState({});
//   const [categoryPage, setCategoryPage] = useState(1);
//   const [subcategoryPage, setSubcategoryPage] = useState(1);
//   const [itemPage, setItemPage] = useState(1);
//   const rowsPerPage = 12;
//   const [error, setError] = useState(null);


//   // useEffect(() => {
//   //   setLoading(true);

//   //   axios
//   //     .get("http://localhost:8000/api/abstract/all/abstract")
//   //     .then((res) => {
//   //       const apiItems = res.data?.data || [];

//   //       // keep only active records
//   //       const activeItems = apiItems.filter(
//   //         (item) => String(item.status).toLowerCase() === "active"
//   //       );

//   //       const normalizedData = activeItems.map((item) => {

//   //         const authorName = `${item.submitter_first_name || ""} ${item.submitter_last_name || ""}`.trim();
//   //         const CoauthorName = [
//   //           item?.person2_first_name,
//   //           item?.person3_first_name,
//   //           item?.person4_first_name,
//   //           item?.person5_first_name,
//   //         ]
//   //           .filter(name => typeof name === "string" && name.trim())
//   //           .join(", ") || "N.A";

//   //         return {
//   //           id: item.content_id,
//   //           title: item.title,
//   //           year: String(item.years),
//   //           category: item.category,
//   //           author: authorName || "Unknown",
//   //           Coauthor: CoauthorName || "Unknown",
//   //           summaryabstract: item.summarised_abstract,
//   //           summary: item.abstract,
//   //           description: item.abstract,
//   //           premium: false,
//   //           subcategory: item.sub_category,

//   //           subdata: [
//   //             {
//   //               id: `${item.content_id}-1`,
//   //               title: item.title,
//   //               summary: item.abstract,
//   //               summaryabstract: item.summarised_abstract,
//   //               author: authorName || "Unknown",
//   //               Coauthor: CoauthorName || "Unknown",
//   //               subcategory: item.sub_category,
//   //               category: item.category,
//   //               year: String(item.years),
//   //               link: "",
//   //             },
//   //           ],
//   //         };
//   //       });

//   //       // Map categories to images using name matching
//   //       const categories = [...new Set(normalizedData.map((item) => item.category).filter(Boolean))];
//   //       const imageMap = {};
//   //       categories.forEach((cat) => {
//   //         imageMap[cat] = getCategoryImage(cat);
//   //       });
//   //       setCategoryImages(imageMap);

//   //       // Set default year to 2025 or most recent
//   //       if (normalizedData.length > 0) {
//   //         const years = normalizedData.map((item) => String(item.year)).filter(Boolean);
//   //         const uniqueYears = [...new Set(years)].sort((a, b) => b.localeCompare(a));
//   //         const defaultYear = uniqueYears.includes("2025") ? "2025" : (uniqueYears[0] || "2025");
//   //         setFilters((prev) => ({ ...prev, year: defaultYear }));
//   //       }

//   //       setData(normalizedData);
//   //       setLoading(false);
//   //     })
//   //     .catch((err) => {
//   //       console.error("API Error:", err);

//   //       // Network / CORS / Server down
//   //       if (!err.response) {
//   //         setError({
//   //           status: "NETWORK",
//   //           message: "Unable to connect to server. Please try again later.",
//   //         });
//   //       }
//   //       // HTTP errors
//   //       else {
//   //         const status = err.response.status;

//   //         let message = "Something went wrong.";

//   //         if (status === 401) message = "Session expired. Please login again.";
//   //         else if (status === 403) message = "You do not have permission to access this content.";
//   //         else if (status === 404) message = "Requested content not found.";
//   //         else if (status >= 500) message = "Server error. Please try again later.";

//   //         setError({ status, message });
//   //       }

//   //       setData([]);
//   //       setLoading(false);
//   //     });


//   // }, []);



//   useEffect(() => {
//     const fetchAbstracts = async () => {
//       try {
//         setLoading(true);

//         const normalizedData = await AbstractAPI.getActiveNormalized();

//         // Map categories to images
//         const categories = [
//           ...new Set(
//             normalizedData.map((item) => item.category).filter(Boolean)
//           ),
//         ];

//         const imageMap = {};
//         categories.forEach((cat) => {
//           imageMap[cat] = getCategoryImage(cat);
//         });
//         setCategoryImages(imageMap);

//         // Default year logic
//         if (normalizedData.length > 0) {
//           const years = normalizedData
//             .map((item) => String(item.year))
//             .filter(Boolean);

//           const uniqueYears = [...new Set(years)].sort((a, b) =>
//             b.localeCompare(a)
//           );

//           const defaultYear = uniqueYears.includes("2025")
//             ? "2025"
//             : uniqueYears[0] || "2025";

//           setFilters((prev) => ({ ...prev, year: defaultYear }));
//         }

//         setData(normalizedData);
//       } catch (err) {
//         console.error("API Error:", err);

//         if (!err.response) {
//           setError({
//             status: "NETWORK",
//             message: "Unable to connect to server. Please try again later.",
//           });
//         } else {
//           const status = err.response.status;
//           let message = "Something went wrong.";

//           if (status === 401) message = "Session expired. Please login again.";
//           else if (status === 403)
//             message = "You do not have permission to access this content.";
//           else if (status === 404)
//             message = "Requested content not found.";
//           else if (status >= 500)
//             message = "Server error. Please try again later.";

//           setError({ status, message });
//         }

//         setData([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAbstracts();
//   }, []);

//   useEffect(() => {
//     if (viewMode === "items" && filters.subcategory !== DEFAULTS.subcategory) {
//       setSelectedSubcategory(filters.subcategory);
//     }
//   }, [filters.subcategory, viewMode]);

//   const currentContent = data || [];

//   function resetView() {
//     setViewMode("categories");
//     setSelectedCategory(null);
//     setSelectedSubcategory(null);
//     setExcludedIds([]);
//     setMatchedParentIds([]);
//     setVisibleCount(8);
//     setCategoryPage(1);
//     setSubcategoryPage(1);
//     setItemPage(1);

//     setTimeout(() => {
//       const el = document.querySelector(".content-grid");
//       if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
//     }, 50);
//   }

//   const handleFilterChange = (filterType, value) => {
//     setVisibleCount(8);
//     setFiltersApplied(true);
//     setCategoryPage(1);
//     setSubcategoryPage(1);
//     setItemPage(1);

//     setFilters((prev) => {
//       switch (filterType) {
//         case "year":
//           resetView();
//           return {
//             ...prev,
//             year: value,
//             category: DEFAULTS.category,
//             subcategory: DEFAULTS.subcategory,
//             author: DEFAULTS.author,
//             query: prev.query,
//           };
//         case "category":
//           resetView();
//           return {
//             ...prev,
//             category: value,
//             subcategory: DEFAULTS.subcategory,
//             author: DEFAULTS.author,
//             query: prev.query,
//           };
//         case "subcategory":
//           if (viewMode === "items") {
//             setSelectedSubcategory(value);
//           }
//           return {
//             ...prev,
//             subcategory: value,
//             author: DEFAULTS.author,
//             query: prev.query,
//           };
//         case "author":
//           return {
//             ...prev,
//             author: value,
//             query: prev.query,
//           };
//         case "access":
//           return { ...prev, access: value };
//         case "query":
//           return { ...prev, query: value };
//         default:
//           return { ...prev, [filterType]: value };
//       }
//     });
//   };

//   const clearFilters = () => {
//     resetView();

//     const years = currentContent.map((item) => String(item.year)).filter(Boolean);
//     const uniqueYears = [...new Set(years)].sort((a, b) => b.localeCompare(a));
//     // const defaultYear = uniqueYears.length > 0 ? uniqueYears[0] : DEFAULTS.year;

//     setFilters({
//       ...DEFAULTS,
//       year: "2025",
//     });
//     setFiltersApplied(false);
//   };

//   const filterOptions = useMemo(() => {
//     const list = currentContent;

//     const yearsFromData = list.map((item) => String(item.year)).filter(Boolean);
//     const uniqueYears = [...new Set(yearsFromData)].sort((a, b) => b.localeCompare(a));

//     const byYear = filters.year === DEFAULTS.year
//       ? list
//       : list.filter((it) => String(it.year) === String(filters.year));

//     const categories = [...new Set(byYear.map((item) => item.category).filter(Boolean))].sort();

//     const byYearCategory = filters.category === DEFAULTS.category
//       ? byYear
//       : byYear.filter((it) => it.category === filters.category);

//     const subdataEntries = byYearCategory.flatMap((p) => Array.isArray(p.subdata) ? p.subdata : []);

//     const subcatsFromSubdata = [...new Set(subdataEntries.map((s) => s.subcategory).filter(Boolean))].sort();

//     let authorsFromSubdata;
//     if (filters.subcategory && filters.subcategory !== DEFAULTS.subcategory) {
//       authorsFromSubdata = [
//         ...new Set(
//           subdataEntries
//             .filter((s) => String(s.subcategory) === String(filters.subcategory))
//             .map((s) => s.author)
//             .filter(Boolean)
//         ),
//       ].sort();
//     } else {
//       authorsFromSubdata = [...new Set(subdataEntries.map((s) => s.author).filter(Boolean))].sort();
//     }

//     const querySet = new Set();
//     byYearCategory.forEach((p) => {
//       if (p.title) querySet.add(p.title);
//       if (p.summary) querySet.add(p.summary);
//       if (p.author) querySet.add(p.author);
//       if (p.category) querySet.add(p.category);
//     });
//     subdataEntries.forEach((s) => {
//       if (s.title) querySet.add(s.title);
//       if (s.summary) querySet.add(s.summary);
//       if (s.author) querySet.add(s.author);
//       if (s.subcategory) querySet.add(s.subcategory);
//     });

//     return {
//       years: [DEFAULTS.year, ...uniqueYears],
//       category: [DEFAULTS.category, ...categories],
//       subcategory: [DEFAULTS.subcategory, ...subcatsFromSubdata],
//       authors: [DEFAULTS.author, ...authorsFromSubdata],
//       query: Array.from(querySet).slice(0, 1000),
//       access: [DEFAULTS.access, "Free Content", "Premium Content"],
//     };
//   }, [currentContent, filters.year, filters.category, filters.subcategory]);

//   const filteredContent = useMemo(() => {
//     const q = (filters.query || "").trim().toLowerCase();

//     return currentContent.filter((item) => {
//       const yearMatch = filters.year === DEFAULTS.year || String(item.year) === String(filters.year);
//       const categoryMatch = filters.category === DEFAULTS.category || item.category === filters.category;

//       const accessMatch =
//         filters.access === DEFAULTS.access ||
//         (filters.access === "Free Content" && !item.premium) ||
//         (filters.access === "Premium Content" && item.premium);

//       const parentHay = [
//         item.title || "",
//         item.summary || item.description || "",
//         item.author || "",
//         item.category || "",
//       ].join(" ").toLowerCase();

//       const subItems = Array.isArray(item.subdata) ? item.subdata : [];
//       const subHayParts = subItems.flatMap((s) => [
//         s.title || "",
//         s.summary || "",
//         s.author || "",
//         s.subcategory || "",
//       ]);
//       const subHay = subHayParts.join(" ").toLowerCase();

//       const hay = (parentHay + " " + subHay).trim();
//       const queryMatch = !q || hay.includes(q);

//       let subcatMatch = true;
//       if (filters.subcategory && filters.subcategory !== DEFAULTS.subcategory) {
//         subcatMatch = subItems.some((s) => String(s.subcategory) === String(filters.subcategory));
//       }

//       let authorMatch = true;
//       if (filters.author && filters.author !== DEFAULTS.author) {
//         authorMatch = subItems.some((s) => String(s.author) === String(filters.author));
//       }

//       return yearMatch && categoryMatch && subcatMatch && authorMatch && accessMatch && queryMatch;
//     });
//   }, [currentContent, filters]);

//   const groupedByCategory = useMemo(() => {
//     const q = filters.query.trim().toLowerCase();
//     const map = {};

//     filteredContent.forEach((parent) => {
//       const subMatches = parent.subdata?.filter((sub) =>
//         matchesQuery(sub, q)
//       ) || [];

//       if (subMatches.length > 0 || matchesQuery(parent, q)) {
//         const cat = parent.category || "Uncategorized";
//         if (!map[cat]) map[cat] = [];
//         map[cat].push({
//           ...parent,
//           subdata: subMatches,
//         });
//       }
//     });

//     return map;
//   }, [filteredContent, filters.query]);

//   const groupedBySubcategory = useMemo(() => {
//     if (!selectedCategory) return {};

//     const q = filters.query.trim().toLowerCase();
//     const categoryItems = groupedByCategory[selectedCategory] || [];

//     const map = {};
//     categoryItems.forEach((item) => {
//       item.subdata?.forEach((sub) => {
//         if (matchesQuery(sub, q)) {
//           const subcat = sub.subcategory || "Uncategorized";
//           if (!map[subcat]) map[subcat] = [];
//           map[subcat].push(sub);
//         }
//       });
//     });

//     return map;
//   }, [selectedCategory, groupedByCategory, filters.query]);


//   // const handleCategoryClick = (category) => {
//   //   setSelectedCategory(category);
//   //   setSubcategoryPage(1);
//   //   setViewMode("subcategories");
//   //   setFilters((prev) => ({ ...prev, category }));

//   //   setTimeout(() => {
//   //     const el = document.querySelector(".content-grid");
//   //     if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
//   //   }, 50);
//   // };
//   const handleCategoryClick = (category) => {

//     setSelectedCategoryForAction(category);
//     setShowOptionModal(true);



//     // if (filters.year === "2025") {
//     //   setSelectedCategoryForAction(category);
//     //   setShowOptionModal(true);
//     // } else {
//     //   // Normal flow for other years
//     //   setSelectedCategory(category);
//     //   setFilters(prev => ({
//     //     ...prev,
//     //     category: category
//     //   }));
//     //   setViewMode("subcategories");
//     // }
//   };

//   const handleSubcategoryClick = (subcategory) => {
//     setSelectedSubcategory(subcategory);
//     setItemPage(1);
//     setViewMode("items");
//     setFilters((prev) => ({ ...prev, subcategory }));

//     setTimeout(() => {
//       const el = document.querySelector(".content-grid");
//       if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
//     }, 50);
//   };

//   const handleItemClick = (item) => {
//     setSelectedItemForModal(item);
//     setShowSummaryModal(true);
//   };

//   const handleBack = () => {
//     if (viewMode === "items") {
//       setViewMode("subcategories");
//       setItemPage(1);
//       setSelectedSubcategory(null);
//       setFilters((prev) => ({ ...prev, subcategory: DEFAULTS.subcategory }));
//     } else if (viewMode === "subcategories") {
//       setViewMode("categories");
//       setSelectedCategory(null);
//       setSubcategoryPage(1);
//       setFilters((prev) => ({
//         ...prev,
//         category: DEFAULTS.category,
//         subcategory: DEFAULTS.subcategory,
//       }));
//     }
//   };

//   const closeSummaryModal = () => {
//     setSelectedItemForModal(null);
//     setShowSummaryModal(false);
//   };

//   const categoriesArray = Object.keys(groupedByCategory).sort();
//   const paginatedCategories = categoriesArray.slice(
//     (categoryPage - 1) * rowsPerPage,
//     categoryPage * rowsPerPage
//   );

//   const subcategoriesArray = Object.keys(groupedBySubcategory).sort();
//   const paginatedSubcategories = subcategoriesArray.slice(
//     (subcategoryPage - 1) * rowsPerPage,
//     subcategoryPage * rowsPerPage
//   );

//   const itemsArray = groupedBySubcategory[selectedSubcategory] || [];
//   const paginatedItems = itemsArray.slice(
//     (itemPage - 1) * rowsPerPage,
//     itemPage * rowsPerPage
//   );

//   if (loading) {
//     return (
//       <main className="main-content">
//         <div className="container-iew-container">
//           <div
//             style={{
//               padding: "48px",
//               textAlign: "center",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               gap: "12px",
//             }}
//           >
//             <p>Loading ...</p>
//             <ThreeDot color="#c65100" size="medium" text="" textColor="" />
//           </div>
//         </div>
//       </main>
//     );
//   }

//   if (error) {
//     return (
//       <main className="main-content">
//         <div
//           style={{
//             minHeight: "70vh",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <Result
//             status={
//               error.status === 404
//                 ? "404"
//                 : error.status === 403
//                   ? "403"
//                   : error.status === 401
//                     ? "401"
//                     : "500"
//             }
//             title={
//               error.status === "NETWORK"
//                 ? "Network Error"
//                 : error.status
//             }
//             subTitle={error.message}
//             extra={[
//               <Button
//                 type="primary"
//                 key="retry"
//                 onClick={() => window.location.reload()}
//               >
//                 Retry
//               </Button>,
//             ]}
//           />
//         </div>
//       </main>
//     );
//   }



//   return (
//     <main className="main-content">
//       <div className="container-iew-container">
//         <div className="content-header"></div>

//         <FilterBar
//           filters={filters}
//           filterOptions={filterOptions}
//           onFilterChange={handleFilterChange}
//           onClear={clearFilters}
//           user={user}
//           onShowAuth={onShowAuth}
//           onShowDashboard={onShowDashboard}
//           onLogout={onLogout}
//         />

//         {viewMode !== "categories" && (
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 12,
//               marginTop: 12,
//               marginBottom: 12,
//             }}
//           >
//             <button className="clear-filters-btn" onClick={handleBack}>
//               ← Back
//             </button>
//           </div>
//         )}

//         {viewMode === "categories" && (
//           <>
//             <div className="content-grid">
//               {paginatedCategories.map((category) => {
//                 const items = groupedByCategory[category];
//                 const categoryImage = categoryImages[category] || DEFAULT_CATEGORY_IMAGE;

//                 return (
//                   <div
//                     className="content-card-new"
//                     key={category}
//                     style={{ cursor: "pointer" }}
//                     onClick={() => handleCategoryClick(category)}
//                   >
//                     {categoryImage && (
//                       <div
//                         style={{
//                           width: "100%",
//                           height: "140px",
//                           overflow: "hidden",
//                           borderRadius: "6px 6px 0 0",
//                         }}
//                       >
//                         <img
//                           src={categoryImage}
//                           alt={category}
//                           style={{
//                             width: "100%",
//                             height: "100%",
//                             objectFit: "cover",
//                           }}
//                         />
//                       </div>
//                     )}

//                     <div className="card-content-new">
//                       <h3 className="card-title-new">
//                         {highlightText(category, filters.query)}
//                       </h3>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>

//             {categoriesArray.length > rowsPerPage && (
//               <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
//                 <Pagination
//                   count={Math.ceil(categoriesArray.length / rowsPerPage)}
//                   page={categoryPage}
//                   onChange={(event, value) => setCategoryPage(value)}
//                   color="primary"
//                 />
//               </div>
//             )}
//           </>
//         )}

//         {viewMode === "subcategories" && (
//           <>
//             <h4 className="subcategory-heading">Category - {selectedCategory}</h4>
//             <div className="content-grid">
//               {paginatedSubcategories.map((subcategory) => {
//                 const items = groupedBySubcategory[subcategory];
//                 const itemCount = items.length;

//                 return (
//                   <div
//                     className="content-card-new"
//                     key={subcategory}
//                     style={{ cursor: "pointer" }}
//                     onClick={() => handleSubcategoryClick(subcategory)}
//                   >
//                     <div className="card-content-new">
//                       <h3 className="card-title-new">
//                         {highlightText(subcategory, filters.query)}
//                       </h3>
//                       <p className="card-description-new">
//                         {itemCount} item{itemCount > 1 ? "s" : ""}
//                       </p>
//                     </div>
//                     <div className="card-actions-new">
//                       <button
//                         className="summary-btn-new"
//                         onClick={() => handleSubcategoryClick(subcategory)}
//                       >
//                         View
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>

//             {subcategoriesArray.length > rowsPerPage && (
//               <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
//                 <Pagination
//                   count={Math.ceil(subcategoriesArray.length / rowsPerPage)}
//                   page={subcategoryPage}
//                   onChange={(event, value) => setSubcategoryPage(value)}
//                   color="primary"
//                 />
//               </div>
//             )}
//           </>
//         )}

//         {viewMode === "items" && (
//           <>
//             <h4 className="subcategory-heading">Category - {selectedCategory}</h4>
//             <h4 className="subcategory-heading">Subcategory - {selectedSubcategory}</h4>
//             <div className="content-grid">
//               {paginatedItems.map((item) => (
//                 <div
//                   className="content-card-new"
//                   key={item.id}
//                   style={{ cursor: "pointer" }}
//                   onClick={() => handleItemClick(item)}
//                 >
//                   <div className="card-content-new">
//                     <h3 className="card-title-new">
//                       {highlightText(item.title, filters.query)}
//                     </h3>
//                     <p className="card-description-new">
//                       By {highlightText(item.author, filters.query)}
//                     </p>
//                   </div>

//                   <div className="card-actions-new">
//                     <button
//                       className="summary-btn-new"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleItemClick(item);
//                       }}
//                     >
//                       View Content
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {itemsArray.length > rowsPerPage && (
//               <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
//                 <Pagination
//                   count={Math.ceil(itemsArray.length / rowsPerPage)}
//                   page={itemPage}
//                   onChange={(event, value) => setItemPage(value)}
//                   color="primary"
//                 />
//               </div>
//             )}
//           </>
//         )}

//         {showSummaryModal && selectedItemForModal && (
//           <SummaryModal
//             item={selectedItemForModal}
//             onClose={closeSummaryModal}
//             query={filters.query}
//             user={user}

//           />
//         )}
//       </div>
//       {showOptionModal && (
//         <div className="option-overlay" onClick={() => setShowOptionModal(false)}>
//           <div
//             className="option-modal"
//             onClick={(e) => e.stopPropagation()}
//           >
//             {/* Close Button */}
//             <div style={{ position: "relative" }}>

//               <button
//                 onClick={() => setShowOptionModal(false)}
//                 style={{
//                   position: "absolute",
//                   top: "10px",
//                   right: "10px",
//                   background: "transparent",
//                   border: "none",
//                   cursor: "pointer"
//                 }}
//               >
//                 <X size={20} strokeWidth={2} />
//               </button>

//               {/* Modal content yaha aayega */}

//             </div>
//             <h2 className="option-heading">Choose an Option</h2>

//             <div className="option-grid">
//               {/* Watch Video */}
//               <div
//                 className="option-card"
//                 onClick={() =>
//                   navigate("/AIandDigital", {
//                     state: { category: selectedCategoryForAction },
//                   })
//                 }
//               >
//                 <div className="option-icon video">
//                   <Video size={40} strokeWidth={2} />
//                 </div>
//                 <h3>Watch Video</h3>
//                 <p>Explore video content</p>
//               </div>

//               {/* Read Summary */}
//               <div
//                 className="option-card"
//                 onClick={() => {
//                   setSelectedCategory(selectedCategoryForAction);
//                   setFilters((prev) => ({
//                     ...prev,
//                     category: selectedCategoryForAction,
//                   }));
//                   setViewMode("subcategories");
//                   setShowOptionModal(false);
//                 }}
//               >
//                 <div className="option-icon summary">
//                   <BookOpen size={40} strokeWidth={2} />
//                 </div>
//                 <h3>Read Summary</h3>
//                 <p>Open summary article</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </main>
//   );
// };

// export default MainContent;



import React, { useState, useMemo, useEffect } from "react";
import FilterBar from "./FilterBar";
import "../style/maincontent.css";
import CloseIcon from "@mui/icons-material/Close";
import { jsPDF } from "jspdf";
import IEW_logo from "../assets/images/IEW_logo.png";
import axios from "axios";
import { ThreeDot } from "react-loading-indicators";
import Pagination from "@mui/material/Pagination";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { X, Video, BookOpen } from "lucide-react";
import { AbstractAPI } from "../api";

import { AlertCircle, RefreshCcw } from "lucide-react";


// Import all 25 dashboard images
import img1 from "../assets/images/Dashboard/1.jpg";
import img2 from "../assets/images/Dashboard/2.jpg";
import img3 from "../assets/images/Dashboard/3.jpg";
import img4 from "../assets/images/Dashboard/4.jpg";
import img5 from "../assets/images/Dashboard/5.jpg";
import img6 from "../assets/images/Dashboard/6.jpg";
import img7 from "../assets/images/Dashboard/7.jpg";
import img8 from "../assets/images/Dashboard/8.jpg";
import img9 from "../assets/images/Dashboard/9.jpg";
import img10 from "../assets/images/Dashboard/10.jpg";
import img11 from "../assets/images/Dashboard/11.jpg";
import img12 from "../assets/images/Dashboard/12.jpg";
import img13 from "../assets/images/Dashboard/13.jpg";
import img14 from "../assets/images/Dashboard/14.jpg";
import img15 from "../assets/images/Dashboard/15.jpg";
import img16 from "../assets/images/Dashboard/16.jpg";
import img17 from "../assets/images/Dashboard/17.jpg";
import img18 from "../assets/images/Dashboard/18.jpg";
import img19 from "../assets/images/Dashboard/19.jpg";
import img20 from "../assets/images/Dashboard/20.jpg";
import img21 from "../assets/images/Dashboard/21.jpg";
import img22 from "../assets/images/Dashboard/22.jpg";
import img23 from "../assets/images/Dashboard/23.jpg";
import img24 from "../assets/images/Dashboard/24.jpg";
import img25 from "../assets/images/Dashboard/25.jpg";


const CATEGORY_IMAGE_MAP = {
  "AI and Digital Transformation": img1,
  "AI, Digital Transformation & New Technologies": img1,
  "Alternative Fuels & Renewable Energy": img2,
  "ALTERNATIVE FUELS & RENEWABLES DEVELOPMENT & TECHNOLOGY": img2,
  "Biofuels and Alternative Fuels": img3,
  "Carbon Capture Utilisation and Storage": img4,
  "Clean Cooking": img5,
  "ClimateTech": img6,
  "DIGITAL TRANSFORMATION & NEW TECHNOLOGY": img7,
  "Energy Markets, Strategies & Finance": img8,
  "Energy Transition, Decarbonisation & Environment": img9,
  "Energy Transition, Decarbonisation": img9,
  "EXPLORATION, PRODUCTION & DEVELOPMENT": img10,
  "Future Mobility": img11,
  "Health, Safety, Security and Environment": img12,
  "Hydrocarbons - Exploration, Production & Development": img13,
  "Hydrocarbons: Exploration, Production and Development": img13,
  "Hydrogen Production, Development & End Use": img14,
  "Manufacturing & Industrialisation": img15,
  "Marine Operations, Logistics and Supply Chain": img16,
  "Mining & Minerals": img17,
  "Natural Gas and LNG Processing, Operations": img18,
  "GAS/LNG PROCESSING, OPERATIONS & TECHNOLOGY": img18,
  "Gas: Processing, Operations & Technology": img18,
  "Organisational Readiness and Operational Excellence": img19,
  "OPERATIONAL EXCELLENCE": img19,
  "People Development": img20,
  "PROJECT MANAGEMENT": img21,
  "Refining & Petrochemicals Technology, Operations": img22,
  "Renewable Energy": img23,
  "Transportation, Storage & Infrastructure": img24,
  "Transportation, Storage and Infrastructure": img24,
  "TRANSPORTATION, STORAGE & INFRASTRUCTURE": img24,
  "Utilities & Power Generation": img25,
};


const DEFAULT_CATEGORY_IMAGE = img1;

const getCategoryImage = (categoryName) => {
  if (!categoryName) return DEFAULT_CATEGORY_IMAGE;

  // Direct match
  if (CATEGORY_IMAGE_MAP[categoryName]) {
    return CATEGORY_IMAGE_MAP[categoryName];
  }

  // Case-insensitive match
  const lowerCategoryName = categoryName.toLowerCase().trim();
  const matchedKey = Object.keys(CATEGORY_IMAGE_MAP).find(
    key => key.toLowerCase().trim() === lowerCategoryName
  );

  if (matchedKey) {
    return CATEGORY_IMAGE_MAP[matchedKey];
  }

  // Partial match (if category name contains any key or vice versa)
  const partialMatchKey = Object.keys(CATEGORY_IMAGE_MAP).find(
    key => {
      const keyLower = key.toLowerCase();
      return lowerCategoryName.includes(keyLower) || keyLower.includes(lowerCategoryName);
    }
  );

  if (partialMatchKey) {
    return CATEGORY_IMAGE_MAP[partialMatchKey];
  }

  return DEFAULT_CATEGORY_IMAGE;
};

// Helper: split and render with bold as new blocks
export const formatBoldText = (text = "") => {
  if (!text) return null;

  const parts = text.split(/(\*\*.*?\*\*)/g);

  return parts.map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      const clean = part.slice(2, -2).trim();
      return <strong key={index}>{clean}</strong>;
    }

    if (part.trim()) {
      return <span key={index}>{part}</span>;
    }

    return null;
  });
};

// Updated highlightText – now composes with the block-aware bold formatter
export const highlightText = (text, query) => {
  if (!query) {
    return formatBoldText(text);
  }

  // First split on the search query (case insensitive)
  const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, index) => {
    const lowerPart = part.toLowerCase();
    const lowerQuery = query.toLowerCase();

    if (lowerPart === lowerQuery) {
      // Highlighted term → wrap in <mark>, but still let formatBoldText handle ** inside it
      return <mark key={index}>{formatBoldText(part)}</mark>;
    }

    // Non-highlighted → just pass through formatBoldText (which will create blocks for bold)
    return formatBoldText(part);
  });
};
export const highlightParagraphs = (text = "", query = "") => {
  if (!text) return null;
  const paras = String(text).split(/\n{2,}/g);
  return paras.map((p, idx) => {
    const pieces = p.split(/\n/g);
    return (
      <p key={idx} className="summary-paragraph">
        {pieces.map((piece, i) => (
          <span key={i}>
            {highlightText(piece, query)}
            {i < pieces.length - 1 && <br />}
          </span>
        ))}
      </p>
    );
  });
};

export const splitSummaryByFullStop = (text = "", sentencesPerPara = 3) => {
  if (!text) return [];

  const sentences = text
    .split(".")
    .map(s => s.trim())
    .filter(Boolean);

  const paragraphs = [];
  for (let i = 0; i < sentences.length; i += sentencesPerPara) {
    paragraphs.push(
      sentences.slice(i, i + sentencesPerPara).join(". ") + "."
    );
  }

  return paragraphs;
};

const drawJustifiedParagraph = (doc, text, x, y, maxWidth, lineHeight) => {
  const words = text.split(/\s+/);
  let line = [];
  let cursorY = y;

  words.forEach((word, index) => {
    const testLine = [...line, word].join(" ");
    const testWidth = doc.getTextWidth(testLine);

    if (testWidth > maxWidth && line.length > 0) {
      const lineText = line.join(" ");
      const spaceCount = line.length - 1;

      if (spaceCount > 0) {
        const textWidth = doc.getTextWidth(lineText.replace(/\s+/g, ""));
        const extraSpace = (maxWidth - textWidth) / spaceCount;

        let cursorX = x;
        line.forEach((w, i) => {
          doc.text(w, cursorX, cursorY);
          cursorX += doc.getTextWidth(w);
          if (i < line.length - 1) cursorX += extraSpace;
        });
      } else {
        doc.text(lineText, x, cursorY);
      }

      cursorY += lineHeight;
      line = [word];
    } else {
      line.push(word);
    }

    if (index === words.length - 1) {
      doc.text(line.join(" "), x, cursorY);
    }
  });

  return cursorY + lineHeight;
};

const makeSafeFileName = (str = "document") =>
  str
    .toString()
    .trim()
    .replace(/[^a-z0-9_\-\. ]/gi, "_")
    .replace(/\s+/g, "_")
    .slice(0, 120);

const loadImageDataUrl = (url, opacity = 0.12) => {
  return new Promise((resolve, reject) => {
    if (!url) return resolve(null);
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      try {
        const MAX_W = 200;
        const scale = img.naturalWidth > MAX_W ? MAX_W / img.naturalWidth : 1;
        const w = Math.round(img.naturalWidth * scale);
        const h = Math.round(img.naturalHeight * scale);

        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");

        // ✅ White background (JPEG ke liye zaroori)
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, w, h);

        // ✅ Logo directly low opacity pe draw karo — no pixel manipulation needed
        ctx.globalAlpha = opacity;
        ctx.drawImage(img, 0, 0, w, h);
        ctx.globalAlpha = 1;

        // ✅ JPEG — small size, no overflow
        const dataUrl = canvas.toDataURL("image/jpeg", 0.5);
        resolve({ dataUrl, width: w, height: h });
      } catch (err) {
        reject(err);
      }
    };
    img.onerror = (e) => reject(e);
    img.src = url;
  });
};
const SummaryModal = ({ item, onClose, query, user, color, type }) => {
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!item) return null;

  // ==================== DOWNLOAD HANDLERS (Updated) ====================

  const handleTrackAndDownload = async (itemToSave, type) => {
    if (!itemToSave) return;

    setDownloading(true);

    try {
      const loggedInUser = user;   // jo bhi aapka user object hai

      // 1. Track Download in Database (Single API)
      await AbstractAPI.trackDownload({
        userId: loggedInUser?.id || loggedInUser?._id,
        username:
          `${loggedInUser?.first_name || ""} ${loggedInUser?.last_name || ""}`.trim() ||
          loggedInUser?.email ||
          "Guest User",
        email: loggedInUser?.email,


        fileId: itemToSave.content_id || itemToSave.id || itemToSave._id,
        fileTitle: itemToSave.title,
        downloadType: type,                    // "pdf" or "ppt"
        filePath: type === "pdf"
          ? (itemToSave.filepath || itemToSave.file_path)
          : itemToSave.filepath,
      });

      // 2. Actual Download
      if (type === "pdf") {
        await handleDownloadPdf(itemToSave);
      } else {
        await handleDownloadFile(itemToSave.filepath);
      }

    } catch (error) {
      console.error(`Download tracking failed for ${type}:`, error);
      // User ko sirf download related message do
      alert(`Failed to ${type === "pdf" ? "generate" : "download"} file. Please try again.`);
    } finally {
      setDownloading(false);
    }
  };

  const handleDownloadPdf = async (itemToSave = item) => {
    if (!itemToSave) return;

    let logo = null;
    try {
      logo = await loadImageDataUrl(IEW_logo, 0.35); // 15% opacity watermark
    } catch {
      logo = null;
    }

    const doc = new jsPDF({ unit: "mm", format: "a4" });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 15;
    const maxLineWidth = pageWidth - margin * 2;
    const labelFontSize = 11;
    const bodyFontSize = 11;
    const lineHeight = 6;

    let cursorY = margin;
    let currentPage = 1;
    const pagesWithLogo = new Set();

    // ✅ Watermark: fixed 60mm wide, centered on page
    const WATERMARK_W = 80;

    const drawWatermarkOnPage = (pageNum) => {
      if (!logo || pagesWithLogo.has(pageNum)) return;
      doc.setPage(pageNum);

      const logoH = WATERMARK_W * (logo.height / logo.width);
      const x = (pageWidth - WATERMARK_W) / 2;
      const y = (pageHeight - logoH) / 2;

      doc.addImage(
        logo.dataUrl,
        "JPEG",       // ✅ JPEG not PNG
        x,
        y,
        WATERMARK_W,
        logoH
      );

      pagesWithLogo.add(pageNum);
    };

    const ensureWatermark = () => drawWatermarkOnPage(currentPage);

    const checkPageBreak = () => {
      if (cursorY + lineHeight > pageHeight - margin) {
        doc.addPage();
        currentPage++;
        cursorY = margin;
        ensureWatermark(); // ✅ watermark on every new page
      }
    };

    const addLabelValue = (label, value) => {
      if (!value) return;
      checkPageBreak();
      doc.setFont("helvetica", "bold");
      doc.setFontSize(labelFontSize);
      doc.text(label, margin, cursorY);
      cursorY += lineHeight;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(bodyFontSize);
      const lines = doc.splitTextToSize(String(value).slice(0, 300), maxLineWidth);
      for (const line of lines) {
        checkPageBreak();
        doc.text(line, margin, cursorY);
        cursorY += lineHeight;
      }
      cursorY += 2;
    };

    // ✅ Draw watermark on page 1
    ensureWatermark();

    if (itemToSave.title) {
      addLabelValue("Title:", itemToSave.title);
      cursorY += 2;
    }

    addLabelValue("Category:", itemToSave.category);
    addLabelValue("Subcategory:", itemToSave.subcategory || itemToSave.sub_category);

    const paperYear =
      itemToSave?.year ||
      itemToSave?.years ||
      itemToSave?.Year ||
      itemToSave?.parent?.year;
    addLabelValue("Year:", String(paperYear || ""));
    addLabelValue("Author:", itemToSave.author || itemToSave.submitter_first_name || "");

    if (itemToSave.Coauthor?.trim()) {
      addLabelValue("Co-Author:", itemToSave.Coauthor);
    }

    const loggedInUserName =
      user?.full_name || user?.name || user?.username || user?.email || "Guest User";
    addLabelValue("Downloaded By:", loggedInUserName);

    checkPageBreak();
    doc.line(margin, cursorY, pageWidth - margin, cursorY);
    cursorY += 8;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(labelFontSize);
    doc.text("Content:", margin, cursorY);
    cursorY += lineHeight + 2;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(bodyFontSize);

    // ✅ Hard cap 3000 chars to prevent buildDocument overflow
    const rawContent = (
      itemToSave.summary ||
      itemToSave.summaryabstract ||
      ""
    ).slice(0, 3000);

    const paragraphs = rawContent.split(/\n+/).filter((p) => p.trim());

    for (const para of paragraphs) {
      const lines = doc.splitTextToSize(para.trim(), maxLineWidth);
      for (const line of lines) {
        checkPageBreak();
        doc.text(line, margin, cursorY);
        cursorY += lineHeight;
      }
      cursorY += 3;
    }

    doc.setProperties({
      title: (itemToSave.title || "Document").slice(0, 100),
      author: (itemToSave.author || "").slice(0, 100),
      subject: (itemToSave.subcategory || "").slice(0, 100),
    });

    doc.save(
      `${makeSafeFileName(
        itemToSave.title || itemToSave.subcategory || "summary"
      )}_summary.pdf`
    );
  };

  // handleDownloadFile ko aise hi rakho (sirf actual file download)
  const handleDownloadFile = async (filepath) => {
    if (!filepath?.trim()) {
      alert("No file path available.");
      return;
    }
    try {
      await AbstractAPI.downloadFile(filepath);
    } catch (error) {
      console.error("Download failed:", error);
      alert("File download failed.");
    }
  };


  return (
    <div className="modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <h2 className="modal-title">{highlightText(item.title, query)}</h2>
          <button className="modal-close" onClick={onClose} aria-label="Close summary">
            <CloseIcon />
          </button>
        </header>

        <section className="modal-body">
          <div style={{ marginBottom: 16 }}>
            <div>
              <strong>Category:</strong>{" "}
              {highlightText(item.category, query)}
            </div>
            <div>
              <strong>Subcategory:</strong>{" "}
              {highlightText(item.subcategory, query)}
            </div>
            <div>
              <strong>Author:</strong>{" "}
              {highlightText(item.author, query)}
            </div>

            {item.Coauthor &&
              item.Coauthor.trim() &&
              item.Coauthor.trim().toLowerCase() !== "n.a" &&
              item.Coauthor.trim().toLowerCase() !== "n/a" &&
              item.Coauthor.trim().toLowerCase() !== "na" && (
                <div>
                  <strong>Co-Author:</strong>{" "}
                  {highlightText(item.Coauthor, query)}
                </div>
              )}
          </div>

          <div className="summary-wrapper" role="article">
            <strong style={{ display: "block", textAlign: "center" }}>
              AI Generated Abstract
            </strong>
            <br />
            <div className="summary-justified">
              {splitSummaryByFullStop(item.summaryabstract || "", 3).map((para, idx) => (
                <div key={idx} className="summary-paragraph">
                  {highlightText(para, query)}
                </div>
              ))}
            </div>
          </div>
        </section>

        <footer className="modal-footer">
          <button
            className="modal-download"
            onClick={() => handleTrackAndDownload(item, "pdf")}
            disabled={downloading}
          >
            {downloading ? "Generating PDF..." : "Download Full Paper"}
          </button>

          <button
            className="modal-download"
            onClick={() => handleTrackAndDownload(item, "ppt")}
            disabled={downloading || !item?.filepath}
          >
            {downloading ? "Downloading..." : "Download Presentation"}
          </button>

          {downloading && (
            <div className="download-loader">
              <p>Please wait...</p>
              <ThreeDot color="#c65100" size="medium" />
            </div>
          )}
        </footer>
      </div>
    </div>
  );
};
const DEFAULTS = {
  year: "All Years",
  category: "All Categories",
  subcategory: "All Subcategories",
  author: "All Authors",
  access: "All Content",
  query: "",
};

const matchesQuery = (item, q) => {
  if (!q) return true;

  const text = [
    item.title,
    item.summary,
    item.summaryabstract,
    item.author,
    item.Coauthor,
    item.category,
    item.subcategory,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return text.includes(q);
};


const MainContent = ({
  user,
  activeTab,
  setActiveTab,
  onShowAuth,
  onShowDashboard,
  onLogout,
}) => {
  const navigate = useNavigate();
  const [visibleCount, setVisibleCount] = useState(8);
  const [filters, setFilters] = useState({ ...DEFAULTS });
  const [excludedIds, setExcludedIds] = useState([]);
  const [showOptionModal, setShowOptionModal] = useState(false);
  const [selectedCategoryForAction, setSelectedCategoryForAction] = useState(null);
  const [viewMode, setViewMode] = useState("categories");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [selectedItemForModal, setSelectedItemForModal] = useState(null);
  const [showSummaryModal, setShowSummaryModal] = useState(false);

  const [filtersApplied, setFiltersApplied] = useState(false);
  const [matchedParentIds, setMatchedParentIds] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryImages, setCategoryImages] = useState({});
  const [categoryPage, setCategoryPage] = useState(1);
  const [subcategoryPage, setSubcategoryPage] = useState(1);
  const [itemPage, setItemPage] = useState(1);
  const rowsPerPage = 12;
  const [error, setError] = useState(null);


  // useEffect(() => {
  //   setLoading(true);

  //   axios
  //     .get("http://localhost:8000/api/abstract/all/abstract")
  //     .then((res) => {
  //       const apiItems = res.data?.data || [];

  //       // keep only active records
  //       const activeItems = apiItems.filter(
  //         (item) => String(item.status).toLowerCase() === "active"
  //       );

  //       const normalizedData = activeItems.map((item) => {

  //         const authorName = `${item.submitter_first_name || ""} ${item.submitter_last_name || ""}`.trim();
  //         const CoauthorName = [
  //           item?.person2_first_name,
  //           item?.person3_first_name,
  //           item?.person4_first_name,
  //           item?.person5_first_name,
  //         ]
  //           .filter(name => typeof name === "string" && name.trim())
  //           .join(", ") || "N.A";

  //         return {
  //           id: item.content_id,
  //           title: item.title,
  //           year: String(item.years),
  //           category: item.category,
  //           author: authorName || "Unknown",
  //           Coauthor: CoauthorName || "Unknown",
  //           summaryabstract: item.summarised_abstract,
  //           summary: item.abstract,
  //           description: item.abstract,
  //           premium: false,
  //           subcategory: item.sub_category,

  //           subdata: [
  //             {
  //               id: `${item.content_id}-1`,
  //               title: item.title,
  //               summary: item.abstract,
  //               summaryabstract: item.summarised_abstract,
  //               author: authorName || "Unknown",
  //               Coauthor: CoauthorName || "Unknown",
  //               subcategory: item.sub_category,
  //               category: item.category,
  //               year: String(item.years),
  //               link: "",
  //             },
  //           ],
  //         };
  //       });

  //       // Map categories to images using name matching
  //       const categories = [...new Set(normalizedData.map((item) => item.category).filter(Boolean))];
  //       const imageMap = {};
  //       categories.forEach((cat) => {
  //         imageMap[cat] = getCategoryImage(cat);
  //       });
  //       setCategoryImages(imageMap);

  //       // Set default year to 2025 or most recent
  //       if (normalizedData.length > 0) {
  //         const years = normalizedData.map((item) => String(item.year)).filter(Boolean);
  //         const uniqueYears = [...new Set(years)].sort((a, b) => b.localeCompare(a));
  //         const defaultYear = uniqueYears.includes("2025") ? "2025" : (uniqueYears[0] || "2025");
  //         setFilters((prev) => ({ ...prev, year: defaultYear }));
  //       }

  //       setData(normalizedData);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.error("API Error:", err);

  //       // Network / CORS / Server down
  //       if (!err.response) {
  //         setError({
  //           status: "NETWORK",
  //           message: "Unable to connect to server. Please try again later.",
  //         });
  //       }
  //       // HTTP errors
  //       else {
  //         const status = err.response.status;

  //         let message = "Something went wrong.";

  //         if (status === 401) message = "Session expired. Please login again.";
  //         else if (status === 403) message = "You do not have permission to access this content.";
  //         else if (status === 404) message = "Requested content not found.";
  //         else if (status >= 500) message = "Server error. Please try again later.";

  //         setError({ status, message });
  //       }

  //       setData([]);
  //       setLoading(false);
  //     });


  // }, []);



  useEffect(() => {
    const fetchAbstracts = async () => {
      try {
        setLoading(true);

        const normalizedData = await AbstractAPI.getActiveNormalized();

        // Map categories to images
        const categories = [
          ...new Set(
            normalizedData.map((item) => item.category).filter(Boolean)
          ),
        ];

        const imageMap = {};
        categories.forEach((cat) => {
          imageMap[cat] = getCategoryImage(cat);
        });
        setCategoryImages(imageMap);

        // Default year logic
        if (normalizedData.length > 0) {
          const years = normalizedData
            .map((item) => String(item.year))
            .filter(Boolean);

          const uniqueYears = [...new Set(years)].sort((a, b) =>
            b.localeCompare(a)
          );

          const defaultYear = uniqueYears.includes("2025")
            ? "2025"
            : uniqueYears[0] || "2025";

          setFilters((prev) => ({ ...prev, year: defaultYear }));
        }

        setData(normalizedData);
      } catch (err) {
        console.error("API Error:", err);

        if (!err.response) {
          setError({
            status: "NETWORK",
            message: "Unable to connect to server. Please try again later.",
          });
        } else {
          const status = err.response.status;
          let message = "Something went wrong.";

          if (status === 401) message = "Session expired. Please login again.";
          else if (status === 403)
            message = "You do not have permission to access this content.";
          else if (status === 404)
            message = "Requested content not found.";
          else if (status >= 500)
            message = "Server error. Please try again later.";

          setError({ status, message });
        }

        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAbstracts();
  }, []);

  useEffect(() => {
    if (viewMode === "items" && filters.subcategory !== DEFAULTS.subcategory) {
      setSelectedSubcategory(filters.subcategory);
    }
  }, [filters.subcategory, viewMode]);

  const currentContent = data || [];

  function resetView() {
    setViewMode("categories");
    setSelectedCategory(null);
    setSelectedSubcategory(null);
    setExcludedIds([]);
    setMatchedParentIds([]);
    setVisibleCount(8);
    setCategoryPage(1);
    setSubcategoryPage(1);
    setItemPage(1);

    setTimeout(() => {
      const el = document.querySelector(".content-grid");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 50);
  }

  const handleFilterChange = (filterType, value) => {
    setVisibleCount(8);
    setFiltersApplied(true);
    setCategoryPage(1);
    setSubcategoryPage(1);
    setItemPage(1);

    setFilters((prev) => {
      switch (filterType) {
        case "year":
          resetView();
          return {
            ...prev,
            year: value,
            category: DEFAULTS.category,
            subcategory: DEFAULTS.subcategory,
            author: DEFAULTS.author,
            query: prev.query,
          };
        case "category":
          resetView();
          return {
            ...prev,
            category: value,
            subcategory: DEFAULTS.subcategory,
            author: DEFAULTS.author,
            query: prev.query,
          };
        case "subcategory":
          if (viewMode === "items") {
            setSelectedSubcategory(value);
          }
          return {
            ...prev,
            subcategory: value,
            author: DEFAULTS.author,
            query: prev.query,
          };
        case "author":
          return {
            ...prev,
            author: value,
            query: prev.query,
          };
        case "access":
          return { ...prev, access: value };
        case "query":
          return { ...prev, query: value };
        default:
          return { ...prev, [filterType]: value };
      }
    });
  };

  const clearFilters = () => {
    resetView();

    const years = currentContent.map((item) => String(item.year)).filter(Boolean);
    const uniqueYears = [...new Set(years)].sort((a, b) => b.localeCompare(a));
    // const defaultYear = uniqueYears.length > 0 ? uniqueYears[0] : DEFAULTS.year;

    setFilters({
      ...DEFAULTS,
      year: "2025",
    });
    setFiltersApplied(false);
  };

  const filterOptions = useMemo(() => {
    const list = currentContent;

    const yearsFromData = list.map((item) => String(item.year)).filter(Boolean);
    const uniqueYears = [...new Set(yearsFromData)].sort((a, b) => b.localeCompare(a));

    const byYear = filters.year === DEFAULTS.year
      ? list
      : list.filter((it) => String(it.year) === String(filters.year));

    const categories = [...new Set(byYear.map((item) => item.category).filter(Boolean))].sort();

    const byYearCategory = filters.category === DEFAULTS.category
      ? byYear
      : byYear.filter((it) => it.category === filters.category);

    const subdataEntries = byYearCategory.flatMap((p) => Array.isArray(p.subdata) ? p.subdata : []);

    const subcatsFromSubdata = [...new Set(subdataEntries.map((s) => s.subcategory).filter(Boolean))].sort();

    let authorsFromSubdata;
    if (filters.subcategory && filters.subcategory !== DEFAULTS.subcategory) {
      authorsFromSubdata = [
        ...new Set(
          subdataEntries
            .filter((s) => String(s.subcategory) === String(filters.subcategory))
            .map((s) => s.author)
            .filter(Boolean)
        ),
      ].sort();
    } else {
      authorsFromSubdata = [...new Set(subdataEntries.map((s) => s.author).filter(Boolean))].sort();
    }

    const querySet = new Set();
    byYearCategory.forEach((p) => {
      if (p.title) querySet.add(p.title);
      if (p.summary) querySet.add(p.summary);
      if (p.author) querySet.add(p.author);
      if (p.category) querySet.add(p.category);
    });
    subdataEntries.forEach((s) => {
      if (s.title) querySet.add(s.title);
      if (s.summary) querySet.add(s.summary);
      if (s.author) querySet.add(s.author);
      if (s.subcategory) querySet.add(s.subcategory);
    });

    return {
      years: [DEFAULTS.year, ...uniqueYears],
      category: [DEFAULTS.category, ...categories],
      subcategory: [DEFAULTS.subcategory, ...subcatsFromSubdata],
      authors: [DEFAULTS.author, ...authorsFromSubdata],
      query: Array.from(querySet).slice(0, 1000),
      access: [DEFAULTS.access, "Free Content", "Premium Content"],
    };
  }, [currentContent, filters.year, filters.category, filters.subcategory]);

  const filteredContent = useMemo(() => {
    const q = (filters.query || "").trim().toLowerCase();

    return currentContent.filter((item) => {
      const yearMatch = filters.year === DEFAULTS.year || String(item.year) === String(filters.year);
      const categoryMatch = filters.category === DEFAULTS.category || item.category === filters.category;

      const accessMatch =
        filters.access === DEFAULTS.access ||
        (filters.access === "Free Content" && !item.premium) ||
        (filters.access === "Premium Content" && item.premium);

      const parentHay = [
        item.title || "",
        item.summary || item.description || "",
        item.author || "",
        item.category || "",
      ].join(" ").toLowerCase();

      const subItems = Array.isArray(item.subdata) ? item.subdata : [];
      const subHayParts = subItems.flatMap((s) => [
        s.title || "",
        s.summary || "",
        s.author || "",
        s.subcategory || "",
      ]);
      const subHay = subHayParts.join(" ").toLowerCase();

      const hay = (parentHay + " " + subHay).trim();
      const queryMatch = !q || hay.includes(q);

      let subcatMatch = true;
      if (filters.subcategory && filters.subcategory !== DEFAULTS.subcategory) {
        subcatMatch = subItems.some((s) => String(s.subcategory) === String(filters.subcategory));
      }

      let authorMatch = true;
      if (filters.author && filters.author !== DEFAULTS.author) {
        authorMatch = subItems.some((s) => String(s.author) === String(filters.author));
      }

      return yearMatch && categoryMatch && subcatMatch && authorMatch && accessMatch && queryMatch;
    });
  }, [currentContent, filters]);

  const groupedByCategory = useMemo(() => {
    const q = filters.query.trim().toLowerCase();
    const map = {};

    filteredContent.forEach((parent) => {
      const subMatches = parent.subdata?.filter((sub) =>
        matchesQuery(sub, q)
      ) || [];

      if (subMatches.length > 0 || matchesQuery(parent, q)) {
        const cat = parent.category || "Uncategorized";
        if (!map[cat]) map[cat] = [];
        map[cat].push({
          ...parent,
          subdata: subMatches,
        });
      }
    });

    return map;
  }, [filteredContent, filters.query]);

  const groupedBySubcategory = useMemo(() => {
    if (!selectedCategory) return {};

    const q = filters.query.trim().toLowerCase();
    const categoryItems = groupedByCategory[selectedCategory] || [];

    const map = {};
    categoryItems.forEach((item) => {
      item.subdata?.forEach((sub) => {
        if (matchesQuery(sub, q)) {
          const subcat = sub.subcategory || "Uncategorized";
          if (!map[subcat]) map[subcat] = [];
          map[subcat].push(sub);
        }
      });
    });

    return map;
  }, [selectedCategory, groupedByCategory, filters.query]);


  // const handleCategoryClick = (category) => {
  //   setSelectedCategory(category);
  //   setSubcategoryPage(1);
  //   setViewMode("subcategories");
  //   setFilters((prev) => ({ ...prev, category }));

  //   setTimeout(() => {
  //     const el = document.querySelector(".content-grid");
  //     if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  //   }, 50);
  // };
  const handleCategoryClick = (category) => {

    setSelectedCategoryForAction(category);
    setShowOptionModal(true);



    // if (filters.year === "2025") {
    //   setSelectedCategoryForAction(category);
    //   setShowOptionModal(true);
    // } else {
    //   // Normal flow for other years
    //   setSelectedCategory(category);
    //   setFilters(prev => ({
    //     ...prev,
    //     category: category
    //   }));
    //   setViewMode("subcategories");
    // }
  };

  const handleSubcategoryClick = (subcategory) => {
    setSelectedSubcategory(subcategory);
    setItemPage(1);
    setViewMode("items");
    setFilters((prev) => ({ ...prev, subcategory }));

    setTimeout(() => {
      const el = document.querySelector(".content-grid");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 50);
  };

  const handleItemClick = (item) => {
    setSelectedItemForModal(item);
    setShowSummaryModal(true);
  };

  const handleBack = () => {
    if (viewMode === "items") {
      setViewMode("subcategories");
      setItemPage(1);
      setSelectedSubcategory(null);
      setFilters((prev) => ({ ...prev, subcategory: DEFAULTS.subcategory }));
    } else if (viewMode === "subcategories") {
      setViewMode("categories");
      setSelectedCategory(null);
      setSubcategoryPage(1);
      setFilters((prev) => ({
        ...prev,
        category: DEFAULTS.category,
        subcategory: DEFAULTS.subcategory,
      }));
    }
  };

  const closeSummaryModal = () => {
    setSelectedItemForModal(null);
    setShowSummaryModal(false);
  };

  const categoriesArray = Object.keys(groupedByCategory).sort();
  const paginatedCategories = categoriesArray.slice(
    (categoryPage - 1) * rowsPerPage,
    categoryPage * rowsPerPage
  );

  const subcategoriesArray = Object.keys(groupedBySubcategory).sort();
  const paginatedSubcategories = subcategoriesArray.slice(
    (subcategoryPage - 1) * rowsPerPage,
    subcategoryPage * rowsPerPage
  );

  const itemsArray = groupedBySubcategory[selectedSubcategory] || [];
  const paginatedItems = itemsArray.slice(
    (itemPage - 1) * rowsPerPage,
    itemPage * rowsPerPage
  );

  if (loading) {
    return (
      <main className="main-content">
        <div className="container-iew-container">
          <div
            style={{
              padding: "48px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <p>Loading ...</p>
            <ThreeDot color="#c65100" size="medium" text="" textColor="" />
          </div>
        </div>
      </main>
    );
  }

  if (error) {
    return (
      <main className="main-content">
        <div
          style={{
            minHeight: "70vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Result
            status={
              error.status === 404
                ? "404"
                : error.status === 403
                  ? "403"
                  : error.status === 401
                    ? "401"
                    : "500"
            }
            title={
              error.status === "NETWORK"
                ? "Network Error"
                : error.status
            }
            subTitle={error.message}
            extra={[
              <Button
                type="primary"
                key="retry"
                onClick={() => window.location.reload()}
              >
                Retry
              </Button>,
            ]}

          />



          <div
            style={{
              minHeight: "70vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              textAlign: "center",
              gap: "16px",
            }}
          >
            <AlertCircle size={60} color="#c65100" />

            <h2>
              {error.status === "NETWORK" ? "Network Error" : `Error ${error.status}`}
            </h2>

            <p>{error.message}</p>

            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "10px 20px",
                background: "#c65100",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              <RefreshCcw size={16} style={{ marginRight: 6 }} />
              Retry
            </button>
          </div>
        </div>
      </main>
    );
  }



  return (
    <main className="main-content">
      <div className="container-iew-container">
        <div className="content-header"></div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <button
            onClick={() => navigate("/")}
            className="clear-filters-btn"
          >
            ← Back
          </button>
        </div>

        <FilterBar
          filters={filters}
          filterOptions={filterOptions}
          onFilterChange={handleFilterChange}
          onClear={clearFilters}
          user={user}
          onShowAuth={onShowAuth}
          onShowDashboard={onShowDashboard}
          onLogout={onLogout}
        />

        {viewMode !== "categories" && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              marginTop: 12,
              marginBottom: 12,
            }}
          >
            <button className="clear-filters-btn" onClick={handleBack}>
              ← Back
            </button>
          </div>
        )}

        {viewMode === "categories" && (
          <>
            <div className="content-grid">
              {paginatedCategories.map((category) => {
                const items = groupedByCategory[category];
                const categoryImage = categoryImages[category] || DEFAULT_CATEGORY_IMAGE;

                return (
                  <div
                    className="content-card-new"
                    key={category}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleCategoryClick(category)}
                  >
                    {categoryImage && (
                      <div
                        style={{
                          width: "100%",
                          height: "140px",
                          overflow: "hidden",
                          borderRadius: "6px 6px 0 0",
                        }}
                      >
                        <img
                          src={categoryImage}
                          alt={category}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    )}

                    <div className="card-content-new">
                      <h3 className="card-title-new">
                        {highlightText(category, filters.query)}
                      </h3>
                    </div>
                  </div>
                );
              })}
            </div>

            {categoriesArray.length > rowsPerPage && (
              <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
                <Pagination
                  count={Math.ceil(categoriesArray.length / rowsPerPage)}
                  page={categoryPage}
                  onChange={(event, value) => setCategoryPage(value)}
                  color="primary"
                />
              </div>
            )}
          </>
        )}

        {viewMode === "subcategories" && (
          <>
            <h4 className="subcategory-heading">Category - {selectedCategory}</h4>
            <div className="content-grid">
              {paginatedSubcategories.map((subcategory) => {
                const items = groupedBySubcategory[subcategory];
                const itemCount = items.length;

                return (
                  <div
                    className="content-card-new"
                    key={subcategory}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSubcategoryClick(subcategory)}
                  >
                    <div className="card-content-new">
                      <h3 className="card-title-new">
                        {highlightText(subcategory, filters.query)}
                      </h3>
                      <p className="card-description-new">
                        {itemCount} item{itemCount > 1 ? "s" : ""}
                      </p>
                    </div>
                    <div className="card-actions-new">
                      <button
                        className="summary-btn-new"
                        onClick={() => handleSubcategoryClick(subcategory)}
                      >
                        View
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

            {subcategoriesArray.length > rowsPerPage && (
              <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
                <Pagination
                  count={Math.ceil(subcategoriesArray.length / rowsPerPage)}
                  page={subcategoryPage}
                  onChange={(event, value) => setSubcategoryPage(value)}
                  color="primary"
                />
              </div>
            )}
          </>
        )}

        {viewMode === "items" && (
          <>
            <h4 className="subcategory-heading">Category - {selectedCategory}</h4>
            <h4 className="subcategory-heading">Subcategory - {selectedSubcategory}</h4>
            <div className="content-grid">
              {paginatedItems.map((item) => (
                <div
                  className="content-card-new"
                  key={item.id}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleItemClick(item)}
                >
                  <div className="card-content-new">
                    <h3 className="card-title-new">
                      {highlightText(item.title, filters.query)}
                    </h3>
                    <p className="card-description-new">
                      By {highlightText(item.author, filters.query)}
                    </p>
                  </div>

                  <div className="card-actions-new">
                    <button
                      className="summary-btn-new"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleItemClick(item);
                      }}
                    >
                      View Content
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {itemsArray.length > rowsPerPage && (
              <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
                <Pagination
                  count={Math.ceil(itemsArray.length / rowsPerPage)}
                  page={itemPage}
                  onChange={(event, value) => setItemPage(value)}
                  color="primary"
                />
              </div>
            )}
          </>
        )}

        {showSummaryModal && selectedItemForModal && (
          <SummaryModal
            item={selectedItemForModal}
            onClose={closeSummaryModal}
            query={filters.query}
            user={user}

          />
        )}
      </div>
      {showOptionModal && (
        <div className="option-overlay" onClick={() => setShowOptionModal(false)}>
          <div
            className="option-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <div style={{ position: "relative" }}>

              <button
                onClick={() => setShowOptionModal(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer"
                }}
              >
                <X size={20} strokeWidth={2} />
              </button>

              {/* Modal content yaha aayega */}

            </div>
            <h2 className="option-heading">Choose an Option</h2>

            <div className="option-grid">
              {/* Watch Video */}
              <div
                className="option-card"
                // ✅ MainContent.jsx — option modal ka "Watch Video" onClick
                onClick={() => {
                  // Collect all paper titles from this subcategory's subdata
                  const allowedTitles = selectedSubcategory && filters.subcategory !== "All Subcategories"
                    ? (groupedBySubcategory[filters.subcategory] || []).map((item) => item.title)
                    : [];

                  navigate("/AIandDigital", {
                    state: {
                      category: selectedCategoryForAction,
                      subcategory: selectedSubcategory || null,
                      allowedTitles,          // ✅ paper titles pass ho rahe hain
                      query: filters.query || "",
                    },
                  });
                }}
              >
                <div className="option-icon video">
                  <Video size={40} strokeWidth={2} />
                </div>
                <h3>Watch Video</h3>
                <p>Explore video content</p>
              </div>

              {/* Read Summary */}
              <div
                className="option-card"
                onClick={() => {
                  setSelectedCategory(selectedCategoryForAction);
                  setFilters((prev) => ({
                    ...prev,
                    category: selectedCategoryForAction,
                  }));
                  setViewMode("subcategories");
                  setShowOptionModal(false);
                }}
              >
                <div className="option-icon summary">
                  <BookOpen size={40} strokeWidth={2} />
                </div>
                <h3>Read Summary</h3>
                <p>Open summary article</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default MainContent;